import React from "react"
import ReactNative from "react-native"
import dataStore from "app/data/dataStore"
import Device from "app/lib/Device"

import FS from "app/components/FS"
import { colors } from "app/lib/styles"

const { Platform, View, StyleSheet } = ReactNative

export default class ChallengeDifficultyDetails extends React.Component {
  renderDifficultyAttribute(text) {
    return (
      <View style={styles.levelDetailAttribute}>
        <FS.Icon name="checkmark" style={styles.levelDetailAttributeIcon} />
        <FS.Text allowFontScaling={true} style={styles.levelDetailAttributeText}>
          {text}
        </FS.Text>
      </View>
    )
  }

  render() {
    var diff = dataStore.get("challenge_difficulty", this.props.challengeDifficultyId)

    return (
      <View style={[styles.container, this.props.style]}>
        {this.renderDifficultyAttribute(
          `This challenge lasts for ${diff.duration_days} day${
            diff.duration_days === 1 ? "" : "s"
          }`
        )}

        {diff.allowed_slips > 0
          ? this.renderDifficultyAttribute(
              `You get ${diff.allowed_slips} free pass${
                diff.allowed_slips === 1 ? "" : "es"
              }`
            )
          : null}

        {diff.target_times > 0
          ? this.renderDifficultyAttribute(
              `You should aim for ${diff.target_times} time${
                diff.target_times === 1 ? "" : "s"
              } per day`
            )
          : null}
      </View>
    )
  }
}

var styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
  },
  levelDetailAttribute: {
    flexDirection: "row",
    marginVertical: 9,
    alignItems: "center",
  },
  levelDetailAttributeIcon: {
    flex: Platform.OS !== "web" ? 0 : null,
    color: colors.challengeOrange,
    marginRight: 18,
  },
  levelDetailAttributeText: {},
})
